export const initEvents = [
    {
        id: '1',
        title: 'Office Meeting for design',
        start: '2024-09-29T13:06',
        end: '2024-09-29T14:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "#5485e4"
        },
        allDay: false,
        category: 'Office',
    },
    {
        id: '2',
        title: 'Family Dinner',
        start: '2024-09-30T18',
        end: '2024-09-30T20',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Free",
            dotColor: "rgb(37, 184, 101)"
        },
        allDay: false,
        category: 'Family',
    },
    {
        id: '3',
        title: 'Travel',
        start: '2024-10-29T14:06',
        end: '2024-10-29T15:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "rgb(23, 162, 184)"
        },
        allDay: false,
        category: 'Travel',
    },
    {
        id: '4',
        title: 'Birthdays',
        start: '2024-10-12T10:06',
        end: '2024-10-12T11:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Free",
            dotColor: "rgb(71, 94, 119)"
        },
        allDay: false,
        category: 'Birthdays',
    },
    {
        id: '5',
        title: 'Company',
        start: '2024-10-15T09:06',
        end: '2024-10-17T12:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "rgb(61, 199, 190)"
        },
        allDay: false,
        category: 'Company',
    },
    {
        id: '6',
        title: 'Holidays',
        start: '2024-10-18T04:06',
        end: '2024-10-20T05:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Free",
            dotColor: "rgb(88, 86, 214)"
        },
        allDay: false,
        category: 'Holidays',
    },
    {
        id: '7',
        title: 'Private',
        start: '2024-10-20T13:06',
        end: '2024-10-20T14:06',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "rgb(228, 158, 61)"
        },
        allDay: false,
        category: 'Private',
    },
    {
        id: '8',
        title: 'Office Meeting',
        start: '2024-10-25',
        end: '2024-10-26',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "#5485e4"
        },
        allDay: true,
        category: 'Office',
    },
    {
        id: '9',
        title: 'Friend',
        start: '2024-10-14',
        end: '2024-10-15',
        details: {
            details: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio qui ducimus quod quisquam ipsum. Itaque maxime quas vitae repudiandae aut corporis nam necessitatibus culpa soluta.",
            location: "Bangladesh",
            position: "Busy",
            dotColor: "rgb(209, 59, 76)"
        },
        allDay: true,
        category: 'Friend',
    },
]